module.exports = __webpack_public_path__ + "img/icon_zww.43e6e187.png";